import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// One header for every page: optional trail back to the parent pages, icon,
// title, description and the page actions on the right.
// A trail step is {label, to} for a link or {label, onClick} when leaving needs a check first.
export function PageTrail({ items }) {
  return (
    <nav aria-label="Percorso" className="mb-1">
      <ol className="flex min-w-0 flex-wrap items-center gap-1 text-sm text-muted-foreground">
        {items.map((item, index) => (
          <li key={item.label} className="flex min-w-0 items-center gap-1">
            {index > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
            {item.to ? (
              <Link to={item.to} className="inline-flex min-h-11 items-center rounded font-medium text-primary hover:text-primary/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">{item.label}</Link>
            ) : item.onClick ? (
              <button type="button" onClick={item.onClick} className="inline-flex min-h-11 items-center rounded font-medium text-primary hover:text-primary/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">{item.label}</button>
            ) : (
              <span className="truncate">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default function PageHeader({ icon: Icon, title, description, trail, eyebrow, actions, className = "" }) {
  return (
    <header className={`flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between ${className}`}>
      <div className="min-w-0">
        {trail?.length > 0 && <PageTrail items={trail} />}
        <div className="flex items-center gap-3">
          {Icon && <span className="icon-tile h-11 w-11" aria-hidden="true"><Icon className="h-6 w-6" /></span>}
          <div className="min-w-0">
            {eyebrow && <p className="text-sm text-muted-foreground">{eyebrow}</p>}
            <h1 className="break-words font-heading text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
            {description && <div className="text-sm text-muted-foreground">{description}</div>}
          </div>
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
